<div class="login-box">
    <img src="assets/not-logged-in.png">
    <p class="tip">{{'login.info' | translate}}<a (click)="login()">{{'login.login' | translate}}</a>LUI</p>
</div>
